import { useQuery } from "react-query"
import { useOrgs } from "../../../components/providers/OrgProvider"
import { ZoneEntity } from "../../types/zone"

export interface ZonesResponse {
  results: ZoneEntity[]
}

interface Props {
  enabled: boolean
}

export function useGetServiceZonesQuery(props?: Props) {
  const { currentOrgs } = useOrgs()
  const currentOrgsUuids = currentOrgs.map(({ uuid }) => uuid)
  const { data, isLoading } = useQuery<ZonesResponse, string>(
    `zones/?organizations=${currentOrgsUuids.join()}&type=cycling_area`,
    { enabled: props ? props.enabled : true },
  )
  const serviceZones = data?.results
  return { serviceZones, serviceLoading: isLoading }
}

export function useGetDropzonesQuery(props: Props) {
  const { currentOrgs } = useOrgs()
  const currentOrgsUuids = currentOrgs.map(({ uuid }) => uuid)
  const { data, isLoading } = useQuery<ZonesResponse, string>(
    `zones/?organizations=${currentOrgsUuids.join()}&type=dropzone&page_size=99&include_bicycle_count=1`,
    { enabled: props ? props.enabled : true },
  )
  const dropzones = data?.results
  return { dropzones, dropzoneLoading: isLoading }
}

export function useGetMaintenanceZonesQuery(props: Props) {
  const { currentOrgs } = useOrgs()
  const currentOrgsUuids = currentOrgs.map(({ uuid }) => uuid)
  const { data, isLoading } = useQuery<ZonesResponse, string>(
    `zones/?organizations=${currentOrgsUuids.join()}&type=maintenance&page_size=99`,
    { enabled: props ? props.enabled : true },
  )
  const maintenanceZones = data?.results
  return { maintenanceZones, dropzoneLoading: isLoading }
}
